import * as components from 'src/components'
import { required, email } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import {
  oauthGoogleAuthenticatorURL,
  oauthFacebookAuthenticatorURL,
  oauthAppleAuthenticatorURL
} from 'src/authenticator'
import { oneOf } from 'src/utils'
import recaptchaService from 'src/recaptcha'
import { Constants } from 'src/constants'

export default {
  components: {
    ...components
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
      context: 'passport/context'
    }),
    oauthGoogleURL () {
      return oauthGoogleAuthenticatorURL(this.config, {
        scope: this.context.scope,
        state: this.context.state,
        refcode: this.context.refcode
      })
    },
    oauthFacebookURL () {
      return oauthFacebookAuthenticatorURL(this.config, {
        scope: this.context.scope,
        state: this.context.state,
        refcode: this.context.refcode
      })
    },
    oauthAppleURL () {
      return oauthAppleAuthenticatorURL(this.config, {
        scope: this.context.scope,
        state: this.context.state,
        refcode: this.context.refcode
      })
    },
    oauthTelegram () {
      return this.config.oauth == null
        ? null
        : this.config.oauth.telegram
    },
    forgotLink () {
      return {
        path: '/security/forgot',
        query: this.$route.query
      }
    },
    signupLink () {
      return {
        path: '/security/signup',
        query: this.$route.query
      }
    }
  },
  data () {
    return {
      form: {
        login: '',
        password: ''
      },
      error: null,
      isErrorVisible: false,
      isBusy: false,
      isPasswordVisible: false,
      colorTheme: Constants.colorTheme
    }
  },
  validations: {
    form: {
      login: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    ...mapActions({
      signin: 'passport/signin',
      describeError: 'errors/describeError'
    }),
    oneOf,
    openLink (link) {
      this.$router.push(link)
    },
    handleLogin (value) {
      this.form.login = value
    },
    handlePassword (value) {
      this.form.password = value
    },
    socialClick () {
    },
    handleSignIn () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.handleSubmit()
      }
    },
    async handleSubmit () {
      this.isBusy = true
      this.isErrorVisible = false
      this.error = null
      setImmediate(async () => {
        try {
          const recaptchaToken = await recaptchaService.getToken()

          await this.signin({
            ...this.form,
            purpose: 'passport',
            recaptchaToken
          })
          setImmediate(() => {
            this.$router.push({
              path: '/security/grant',
              query: this.$route.query
            })
          })
        } catch (e) {
          const { errorMessage } = await this.describeError({ error: e })
          this.error = errorMessage
          this.isErrorVisible = true
        } finally {
          this.isBusy = false
        }
      })
    },
    togglePasswordVisibility () {
      this.isPasswordVisible = !this.isPasswordVisible
    }
  }
}
